import { constants } from "ethers";
import {
  arbitrumGoerli,
  goerli,
  optimismGoerli,
  polygonMumbai,
  mainnet,
  polygon,
  arbitrum,
  optimism,
  zkSyncTestnet,
  zkSync,
} from "wagmi/chains";

export const isEqualLowerString = (ad1 = constants.AddressZero, ad2 = constants.AddressZero) =>
  ad1.toLowerCase() === ad2.toLowerCase();

export const isZksyncNetwork = (chainId) => chainId === process.env.REACT_APP_CHAIN_ID_ZKSYNC;

export const isIncludeNetwork = {
  polygon: process.env.REACT_APP_INCLUDE_POLYGON === "true",
  ethereum: process.env.REACT_APP_INCLUDE_ETHEREUM === "true",
  arbitrum: process.env.REACT_APP_INCLUDE_ARBITRUM === "true",
  optimism: process.env.REACT_APP_INCLUDE_OPTIMISM === "true",
  zkSync: process.env.REACT_APP_INCLUDE_ZKSYNC === "true",
};

const isIncludeNetworkArray = [
  {
    name: "polygon",
    isOn: process.env.REACT_APP_INCLUDE_POLYGON === "true",
    mainnet: polygon,
    testnet: polygonMumbai,
  },
  {
    name: "ethereum",
    isOn: process.env.REACT_APP_INCLUDE_ETHEREUM === "true",
    mainnet,
    testnet: goerli,
  },
  {
    name: "arbitrum",
    isOn: process.env.REACT_APP_INCLUDE_ARBITRUM === "true",
    mainnet: arbitrum,
    testnet: arbitrumGoerli,
  },
  {
    name: "optimism",
    isOn: process.env.REACT_APP_INCLUDE_OPTIMISM === "true",
    mainnet: optimism,
    testnet: optimismGoerli,
  },
  {
    name: "zkSync",
    isOn: process.env.REACT_APP_INCLUDE_ZKSYNC === "true",
    mainnet: zkSync,
    testnet: zkSyncTestnet,
  },
];

export const TestNetwork = isIncludeNetworkArray
  .filter((network) => network.isOn)
  .map((network) => network.testnet);

export const MainNetwork = isIncludeNetworkArray
  .filter((network) => network.isOn)
  .map((network) => network.mainnet);

export const MainNetworkSupported = [1, 137, 42161, 10, 324];
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const isMainNetWork = (chainId) => MainNetworkSupported.includes(+chainId);
